
import { ElMessage } from 'element-plus'

export const responseFilter = (request: any) => {
  return new Promise((resolve, reject) => {
    if (request != null) {
      request.then((response: any) => {
        if (response?.code === 200) {
          resolve(response)
        } else {
          if (response && response.msg) {
            ElMessage.error(response.msg)
          }
          reject(response)
        }
      }).catch((error: any) => {
        reject(error)
      })
    } else {
      reject(new Error('request is null !'))
    }
  })
}
